import type { NiveauPermission, TypePermission } from '@/features/domaine/types/opco/Permissions'

export type PermissionsApp = {
  readonly [p in TypePermission]: NiveauPermission
}

export const PERMISSIONS_AUCUNE: PermissionsApp = {
  CPRO: 'Aucun',
  AF: 'Aucun',
  CAPP: 'Aucun',
  PROA: 'Aucun',
  Facture: 'Aucun',
  Virement: "Aucun",
  RIB: 'Aucun',
  Administration: "Aucun",
}
